<template>
      <div class="custom-category-icon-container">
            <!--<font-awesome-icon v-bind:class="getTopIconClass"  :size="topIconSize"  icon="globe-africa"/>
            <font-awesome-icon class="custom-category-icon custom-category-icon-bottom" :size="bottomIconSize"  icon="hand-holding"/>-->
            <img class="mx-auto icon-img" src="../../assets/Group_18.png" alt="Group_18"/>
      </div>
</template>

<script>
export default {
    name: "HandHoldingGlobe",
    props: ['bottomIconSize', 'topIconSize', 'iconStyle'],
    //computed: {
    //    getTopIconClass: function() {
    //        return this.iconStyle == 'large' ? 'custom-category-icon custom-category-icon-top large-icon' : 'custom-category-icon custom-category-icon-top small-icon';
    //    }
    //}
}
</script>

<style scoped>

</style>
